<div class="bg-image-dashed-cloud"></div>

<div class="maintenance-container">
  <img [src]="brand.logoIcon" class="rocket-image" [alt]="brand.logoAlt" [title]="brand.logoAlt" />

  <h1 class="error-message">System Maintenance in Progress!</h1>
  <div class="flex items-center justify-center gap-2 mb-14">
    <rkt-icon class="schecule-icon" name="schedule" />
    <p class="maintenance-text">{{ brand.displayName }} Portal is under scheduled maintenance</p>
  </div>

  <div class="maintenance-text mb-6">
    <p class="mb-4">Good things are happening! We will be back shortly. We're sorry for the inconvenience.</p>
    <p>
      For questions or immediate assistance, please contact us at
      <a href="https://rocketkor.com/#contact" target="_blank" rel="noopener noreferrer" class="contact-link">rocketkor.com</a>
    </p>
  </div>

  <button rktButton (click)="onBackToDashboardBtnClick()">
    {{ (isAuthenticated$ | async) ? 'Back to Dashboard' : 'Return to Login' }}
  </button>
</div>
